import { GetAllInstrumentConfigurationsResponse } from '@digitalasset/utility-operator-api-ts-client';

export const filterInstConfigsByInstrument = (
  instrumentId: string,
  registrar: string,
  instConfigs?: GetAllInstrumentConfigurationsResponse,
) => {
  if (!instConfigs) {
    return undefined;
  }
  const config = instConfigs.instrumentConfigurations.find(
    (c) =>
      c.payload.defaultIdentifier.id === instrumentId &&
      c.payload.defaultIdentifier.source === registrar,
  );
  return config;
};
